export const promiseTimeout = delay => new Promise(resolve => {
  window.setTimeout(resolve, delay);
});